module.exports = __webpack_public_path__ + "img/5.116c9f87.png";